var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Divider, Text } from '@dixa/lib-shared-habla';
import { ElevioStateDescription, MessengerElevioSettings, } from './components';
/**
 * Elevio integration component used to configure Elevio integration with the
 * messenger
 */
export function ElevioIntegration(_a) {
    var { state, onToggleElevioIntegration, onEditElevioAccountId } = _a, rest = __rest(_a, ["state", "onToggleElevioIntegration", "onEditElevioAccountId"]);
    return (_jsxs("div", { children: [_jsx(Box, Object.assign({ margin: "0 0 300 0" }, { children: _jsx(Text.Heading, Object.assign({ variant: "heading-2" }, { children: "Elevio integration" })) })), _jsx(ElevioStateDescription, { state: state, onToggle: onToggleElevioIntegration }), state.type === 'connected' && state.enabled && (_jsx(MessengerElevioSettings, Object.assign({ state: state }, rest))), _jsx(Box, Object.assign({ margin: "400 0" }, { children: _jsx(Divider, { size: "xSmall" }) })), _jsx(Button, Object.assign({ variant: "secondary", type: "button", onClick: onEditElevioAccountId }, { children: state.type === 'not-connected'
                    ? 'Connect Elevio'
                    : 'Edit Elevio account ID' }))] }));
}
